import { render, staticRenderFns } from "./SideModal.vue?vue&type=template&id=2dc97c36&scoped=true"
import script from "./SideModal.vue?vue&type=script&lang=js"
export * from "./SideModal.vue?vue&type=script&lang=js"
import style0 from "./SideModal.vue?vue&type=style&index=0&id=2dc97c36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc97c36",
  null
  
)

export default component.exports